var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"developer-status"},[_c('v-chip',{attrs:{"color":_vm.statusColor,"text-color":"white","small":""}},[_vm._v(" "+_vm._s(_vm.availabilityLabel)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }